import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from '../dashboard.service';
import { LanguageService } from 'app/shared/language.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface DialogData {
  patid: string;
  userid: number;
  uhid: number;
}


@Component({
  selector: 'app-remove-dilation',
  templateUrl: './remove-dilation.component.html',
  styleUrls: ['./remove-dilation.component.css']
})

export class RemoveDilationComponent implements OnInit {
  destroyremove$: Subject<boolean> = new Subject<boolean>();
  constructor(private authService:AuthService, private dialogRef: MatDialogRef<RemoveDilationComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData, private dashboardService: DashboardService, private translate: TranslateService,
    private langservice: LanguageService,) {
      dialogRef.disableClose = true;
      translate.addLangs(['en', 'fr', 'hi']);
      if (this.langservice.setlang) {
        translate.setDefaultLang(this.langservice.setlang);
      }
      else {
        translate.setDefaultLang('en');
      }
     }

  ngOnInit() { 
  }
  ngOnDestroy() {
    this.destroyremove$.next(true);
    this.destroyremove$.unsubscribe();
  }
  onNoClick(): void {
    this.dashboardService.popup_cancel = true
    this.dialogRef.close();
  }

  removedilasis(){
    this.dashboardService.popup_cancel = false;
    this.getdilationstatus();
   
  }

  getdilationstatus(){
    this.dashboardService.getdialationStart(this.data.patid,this.dashboardService.currenttime,this.dashboardService.dilationwith,this.dashboardService.selectedeye,this.authService.Loggeduser.userid,'remove',this.dashboardService.finishtime).pipe(takeUntil(this.destroyremove$))
    .subscribe(data => this.success_dilation_removed(data),
    err => this.failed_dilation(err));
  }

  success_dilation_removed(data){
    console.log("Dilation Removed");
    this.dialogRef.close();
  }
failed_dilation(err){
  if(err.status==403){
    this.dashboardService.openSnackBar("You Don't have Permission", "OK");
  }else{
    this.dashboardService.openSnackBar("Dilation Removed Fail", "OK");
  }
  this.dialogRef.close();
}

}
